const GenerateColumns = ({ columns = [] }) => {
  return (
    <tr className="text-[#B1B1B1] text-[15px] font-[700] leading-[35px]">
      {columns.map((column) => (
        <th key={column}>{column}</th>
      ))}
    </tr>
  );
};

export default GenerateColumns;
